<template>
  <div id="app" class="coupon-wrapper">
    <img
      src="https://img66.anypromo.com/frontimg/2021/Coupon/coupon-banner.jpg"
      alt=""
      width="1903"
      height="360"
      class="img-fluid"
    />
    <div class="coupon-container">
      <aside>
        <div class="coupon-main-box logo-box">
          <svg v-if="ShowMVP"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 216 56.1"
          >
            <path
              class="st0"
              d="M173 31.9c-.8.8-2.1.8-3 0-.8-.8-.8-2.1 0-3 .8-.8 2.1-.8 3 0 .7.9.8 2.2 0 3"
            />
            <path
              class="st1"
              d="M28.2 19.6H33l6.3 9.3v-9.3h4.9v16.8h-4.9c-2.1-3.1-4.2-6.1-6.3-9.2v9.2h-4.9V19.6zM46 19.6h5.8c1.1 1.9 2.3 3.8 3.4 5.6 1.1-1.9 2.2-3.8 3.4-5.6h5.7c-2.2 3.3-4.3 6.5-6.5 9.8v7h-5.2v-7c-2.3-3.3-4.5-6.6-6.6-9.8"
            />
            <path
              class="st0"
              d="M94.7 26.4h2.2c.2 0 .7-.1 1.4-.2.3-.1.6-.2.8-.5.2-.3.3-.6.3-1 0-.5-.2-1-.5-1.2-.3-.3-1-.4-1.9-.4h-2.3v3.3zm-5.2 9.9V19.6h8.6c1.6 0 2.8.1 3.7.4.8.3 1.5.8 2 1.5s.8 1.7.8 2.7c0 .9-.2 1.7-.6 2.4-.4.7-.9 1.2-1.6 1.6-.4.3-1.1.5-1.8.7.6.2 1.1.4 1.4.6.2.1.5.4.8.9.4.5.6.8.7 1 .8 1.6 1.7 3.2 2.5 4.9h-5.9c-.9-1.7-1.8-3.4-2.8-5.1-.3-.7-.7-1.1-.9-1.3-.4-.3-.8-.4-1.3-.4h-.5v6.8h-5.1zM111.8 28c0 1.7.3 2.9.9 3.6.6.7 1.5 1.1 2.6 1.1s2-.4 2.6-1.1c.6-.7.9-2 .9-3.9 0-1.6-.3-2.7-1-3.5-.6-.7-1.5-1.1-2.6-1.1-1 0-1.9.4-2.5 1.1-.6.9-.9 2.1-.9 3.8m-5.2 0c0-2.7.8-4.9 2.3-6.4 1.5-1.5 3.7-2.3 6.4-2.3 2.8 0 5 .7 6.5 2.2 1.5 1.5 2.3 3.6 2.3 6.3 0 2-.3 3.6-1 4.8-.7 1.3-1.6 2.2-2.9 2.9-1.2.7-2.8 1-4.7 1-1.9 0-3.5-.3-4.7-.9-1.2-.6-2.2-1.6-3-2.9-.8-1.1-1.2-2.8-1.2-4.7M126.8 19.6h6.9c.9 3.4 1.7 6.8 2.6 10.2.9-3.4 1.7-6.8 2.6-10.2h6.8v16.8h-4.3V23.5c-1.1 4.3-2.2 8.5-3.3 12.8h-3.8c-1.1-4.3-2.2-8.5-3.3-12.8v12.8h-4.3V19.6zM153.5 28c0 1.7.3 2.9.9 3.6.6.7 1.5 1.1 2.6 1.1s2-.4 2.6-1.1c.6-.7.9-2 .9-3.9 0-1.6-.3-2.7-1-3.5-.6-.7-1.5-1.1-2.6-1.1-1 0-1.9.4-2.5 1.1-.6.9-.9 2.1-.9 3.8m-5.2 0c0-2.7.8-4.9 2.3-6.4 1.5-1.5 3.7-2.3 6.4-2.3 2.8 0 5 .7 6.5 2.2 1.5 1.5 2.3 3.6 2.3 6.3 0 2-.3 3.6-1 4.8-.7 1.3-1.6 2.2-2.9 2.9-1.3.7-2.8 1-4.7 1-1.9 0-3.5-.3-4.7-.9-1.2-.6-2.2-1.6-3-2.9-.8-1.1-1.2-2.8-1.2-4.7"
            />
            <path
              class="st1"
              d="M15.6 27.3c-.9-2.9-1.7-5.7-2.6-8.6-.9 2.9-1.7 5.7-2.6 8.6h5.2zm1.5 5.2H8.8c-.4 1.3-.8 2.7-1.2 4H0l9-24h8.1l9 24h-7.8c-.4-1.4-.8-2.7-1.2-4"
            />
            <path
              class="st0"
              d="M74.2 22.6H76c1.4 0 2.4-.2 3-.7.6-.5.9-1.1.9-1.9 0-.8-.3-1.4-.8-1.9s-1.4-.8-2.8-.8h-2.1v5.3zm-7.5-10.2H79c2.7 0 4.7.6 6 1.9 1.3 1.3 2 3.1 2 5.4 0 2.4-.7 4.3-2.2 5.7-1.5 1.4-3.7 2-6.7 2H74v8.9h-7.5V12.4z"
            />
            <path
              class="st1"
              d="M182.7 32.5c0 2-.8 2.9-2.8 2.9h-.7c-2.2 0-3-.9-3-3.2v-1.6c0-2.3.7-3.2 3-3.2h.6c2.2 0 2.9.7 2.9 2.8v.2h-2.1v-.1c0-.7-.3-1-1.1-1-1 0-1.1.4-1.1 1.5v1.3c0 1.2.1 1.5 1.1 1.5.8 0 1.1-.3 1.1-1.1v-.2h2.1v.2zM185.9 32.1c0 1.2.1 1.5 1.2 1.5h.4c1.1 0 1.2-.3 1.2-1.5v-1.3c0-1.2-.1-1.5-1.2-1.5h-.5c-1.1 0-1.2.3-1.2 1.5v1.3zm.8-4.7h1c2.2 0 3 .9 3 3.2v1.6c0 2.3-.7 3.2-3 3.2h-1c-2.2 0-3-.9-3-3.2v-1.6c.1-2.3.8-3.2 3-3.2M201.3 27.5v7.8h-2v-5.7c-.5 1.9-1 3.8-1.6 5.7h-2.1c-.5-1.9-1-3.8-1.6-5.8v5.8h-2v-7.8h3c.5 1.9 1.1 3.7 1.6 5.6.5-1.9 1.1-3.7 1.6-5.6h3.1z"
            />
            <path
              class="st0"
              d="M216 9.8c-.9-7.7-21.5-11.7-46-8.9-16.9 1.9-31.3 6.6-38.3 11.8 7.5-3.5 18.3-6.3 30.5-7.7 23.5-2.7 43.2 1.1 44.1 8.5.5 4-4.7 8.2-13.3 11.7 14.2-4 23.6-9.9 23-15.4"
            />
            <path
              class="st1"
              d="M163.7 6.5c-14.6 1.8-27.2 5.7-33.3 10 6.5-2.9 15.9-5.3 26.5-6.6 20.3-2.5 37.2.2 37.7 6.1.3 3.2-4.3 6.6-11.8 9.5 12.4-3.4 20.7-8.2 20.3-12.5-.6-6.3-18.2-9.1-39.4-6.5"
            />
            <path
              d="M2.1 43.7h1.3l-1.8 8.5h5.1l-.3 1.1H.1zM8.8 50.1v.6c0 1.1.9 1.7 1.8 1.7 1 0 1.7-.5 2-1.3h1.1c-.4 1.5-1.6 2.3-3.1 2.3-2.3 0-2.9-1.6-2.9-2.8 0-2.7 1.7-4.5 3.6-4.5 2 0 2.9 1.1 2.9 3.1 0 .4-.1.7-.1.9H8.8zm4.1-1c.1-1-.4-2-1.6-2-1.3 0-2.1.9-2.4 2h4zM17.6 46.3H19l-.2 1h-1.4l-.9 4.1v.5c0 .4.3.5.7.5.2 0 .4-.1.7-.1l-.2 1c-.3.1-.5.1-.8.1-.8 0-1.6-.2-1.6-1.1 0-.2 0-.4.1-.6l.9-4.3h-1.2l.2-1h1.2l.4-2.1H18l-.4 2zM21 43.7h1.5c-.3 1.5-.3 3.3-2.2 3.5l.1-.6c.7-.1.9-.7 1-1.3h-.7l.3-1.6zM26.6 48.4c0-.8-.6-1.2-1.4-1.2-.7 0-1.5.2-1.5.9 0 .6.9.9 1.8 1.3s1.8.9 1.8 1.9c0 1.5-1.5 2.1-2.8 2.1-1.6 0-2.8-.6-2.8-2.3h1.1c-.1 1 .8 1.3 1.8 1.3.8 0 1.6-.3 1.6-1.1 0-.7-.9-.9-1.8-1.3s-1.8-.8-1.8-1.9c0-1.3 1.3-2 2.6-2s2.6.6 2.6 2.2h-1.2zM34.1 43.7h1.8l1.3 8.2 4.7-8.2h1.8l-2 9.6h-1.2l1.9-8.4-4.9 8.4h-1.2l-1.2-8.4H35l-1.7 8.4h-1.2zM44.4 48.4c.2-1.5 1.5-2.3 3-2.3 1.3 0 2.5.4 2.5 1.8 0 .4-.1.9-.2 1.3l-.4 1.9c-.1.3-.2.7-.2 1 0 .3.1.4.3.4.1 0 .3-.1.4-.1l-.2.8c-.2.1-.5.2-.7.2-.6 0-1-.4-.9-1-.5.6-1.1 1-2.3 1-1.2 0-2.1-.5-2.1-2 0-2 2-2.1 3.5-2.3 1.2-.1 1.7-.2 1.7-1.1 0-.7-.8-.9-1.4-.9-.9 0-1.7.3-1.9 1.2h-1.1zm1.6 4c.9 0 1.6-.3 1.9-.9.4-.5.4-1.1.6-1.8-1 .7-3.7 0-3.8 1.7 0 .7.6 1 1.3 1M52.6 43.7h1.1l-1.2 5.6h.1l3.5-3h1.4l-3 2.6 1.7 4.4H55l-1.4-3.7-1.3 1.2-.6 2.5h-1.1zM58.4 50.1v.6c0 1.1.9 1.7 1.8 1.7 1 0 1.7-.5 2-1.3h1.1c-.4 1.5-1.6 2.3-3.1 2.3-2.3 0-2.9-1.6-2.9-2.8 0-2.7 1.7-4.5 3.6-4.5 2 0 2.9 1.1 2.9 3.1 0 .4-.1.7-.1.9h-5.3zm4.2-1c.1-1-.4-2-1.6-2-1.3 0-2.1.9-2.4 2h4zM70.1 43.7h1.8l1.3 8.2 4.7-8.2h1.8l-2 9.6h-1.2l1.9-8.4-4.9 8.4h-1.2l-1.2-8.4H71l-1.7 8.4h-1.2zM80.4 48.4c.2-1.5 1.5-2.3 3-2.3 1.3 0 2.5.4 2.5 1.8 0 .4-.1.9-.2 1.3l-.4 1.9c-.1.3-.2.7-.2 1 0 .3.1.4.3.4.1 0 .3-.1.4-.1l-.2.8c-.2.1-.5.2-.7.2-.6 0-1-.4-.9-1-.5.6-1.1 1-2.3 1-1.2 0-2.1-.5-2.1-2 0-2 2-2.1 3.5-2.3 1.2-.1 1.7-.2 1.7-1.1 0-.7-.8-.9-1.4-.9-.9 0-1.7.3-1.9 1.2h-1.1zm1.6 4c.9 0 1.6-.3 1.9-.9.4-.5.4-1.1.6-1.8-1 .7-3.7 0-3.8 1.7 0 .7.6 1 1.3 1M88 46.3h1.1l-.3 1.5c.5-1 1.4-1.6 2.5-1.6h.4l-.3 1.2H91c-.3 0-.4 0-.7.1-.6.2-1.1.6-1.5 1.1-.3.4-.5 1.1-.6 1.6l-.7 3.1h-1.1l1.6-7zM93.1 43.7h1.1L93 49.3l3.5-3H98l-3 2.6 1.7 4.4h-1.3l-1.3-3.7-1.4 1.2-.5 2.5h-1.1zM98.9 50.1v.6c0 1.1.9 1.7 1.8 1.7 1 0 1.7-.5 2-1.3h1.1c-.4 1.5-1.6 2.3-3.1 2.3-2.3 0-2.9-1.6-2.9-2.8 0-2.7 1.7-4.5 3.6-4.5 2 0 2.9 1.1 2.9 3.1 0 .4-.1.7-.1.9h-5.3zm4.2-1c.1-1-.4-2-1.6-2-1.3 0-2.1.9-2.4 2h4zM107.7 46.3h1.4l-.2 1h-1.4l-.9 4.1v.5c0 .4.3.5.7.5.2 0 .4-.1.7-.1l-.2 1c-.3.1-.5.1-.8.1-.8 0-1.6-.2-1.6-1.1 0-.2 0-.4.1-.6l.9-4.3h-1.2l.2-1h1.2l.4-2.1h1.1l-.4 2zM110.4 46.3h1.1l-1.4 6.9H109l1.4-6.9zm1.4-1.2h-1.2l.3-1.4h1.2l-.3 1.4zM113.4 46.3h1.1l-.2 1c.6-.8 1.5-1.2 2.5-1.2 1.3 0 1.9.6 1.9 1.8 0 .3-.1.8-.2 1.4l-.8 4h-1.1l.9-4c0-.3.2-.8.2-1.1 0-.7-.5-1-1.2-1-.6 0-1.3.3-1.7.8-.4.4-.6.9-.8 1.4l-.8 3.8h-1.1l1.3-6.9zM125.6 52.2c-.2.7-.3 1.4-.5 1.9-.6 1.4-1.7 1.9-3.1 1.9-1.4 0-2.7-.6-2.8-2.1h1.1c.1.9.9 1.1 1.7 1.1 1.8 0 2.1-1.4 2.5-2.8-.5.7-1.3 1.1-2.2 1.1-1.7 0-2.6-1.2-2.6-2.9 0-2 1.4-4.3 3.6-4.3 1 0 2 .6 2.2 1.4l.2-1.3h1.1l-1.2 6zm-3 .1c1.7 0 2.5-1.9 2.5-3.3 0-1.1-.6-1.8-1.8-1.8-1.6 0-2.5 2-2.5 3.3 0 .9.6 1.8 1.8 1.8M133 43.7h1.7l1.3 8.2 4.8-8.2h1.7l-2 9.6h-1.2l1.9-8.4-4.9 8.4h-1.2l-1.2-8.4h-.1l-1.6 8.4h-1.3zM143.2 48.4c.2-1.5 1.5-2.3 3-2.3 1.3 0 2.5.4 2.5 1.8 0 .4-.1.9-.2 1.3l-.4 1.9c-.1.3-.2.7-.2 1 0 .3.1.4.3.4.1 0 .3-.1.4-.1l-.2.8c-.2.1-.5.2-.7.2-.6 0-1-.4-.9-1-.5.6-1.1 1-2.3 1-1.2 0-2.1-.5-2.1-2 0-2 2-2.1 3.5-2.3 1.2-.1 1.7-.2 1.7-1.1 0-.7-.8-.9-1.4-.9-.9 0-1.7.3-1.9 1.2h-1.1zm1.6 4c.9 0 1.6-.3 1.9-.9.4-.5.4-1.1.6-1.8-1 .7-3.7 0-3.8 1.7 0 .7.6 1 1.3 1M151.4 43.7h1.2l-1.2 5.6 3.5-3h1.5l-3.1 2.6 1.8 4.4h-1.3l-1.4-3.7-1.3 1.2-.6 2.5h-1.1zM157.2 50.1v.6c0 1.1.9 1.7 1.8 1.7 1 0 1.7-.5 2-1.3h1.1c-.4 1.5-1.6 2.3-3.1 2.3-2.3 0-2.9-1.6-2.9-2.8 0-2.7 1.7-4.5 3.6-4.5 2 0 2.9 1.1 2.9 3.1 0 .4-.1.7-.1.9h-5.3zm4.2-1c.1-1-.4-2-1.6-2-1.3 0-2.1.9-2.4 2h4zM175.7 50c-.5 2.1-1.9 3.5-4.2 3.5-2.6 0-4.1-1.6-4.1-4.2 0-3.1 2-5.8 5.3-5.8 2.1 0 3.6 1.1 3.6 3.3H175c0-1.5-1-2.2-2.4-2.2-2.7 0-4 2.5-4 4.8 0 1.9.9 3.1 2.8 3.1 1.6 0 2.5-.9 3-2.4h1.3zM177.8 50.1v.6c0 1.1.9 1.7 1.8 1.7 1 0 1.7-.5 2-1.3h1.1c-.4 1.5-1.6 2.3-3.1 2.3-2.3 0-2.9-1.6-2.9-2.8 0-2.7 1.7-4.5 3.6-4.5 2 0 2.9 1.1 2.9 3.1 0 .4-.1.7-.1.9h-5.3zm4.2-1c.1-1-.4-2-1.6-2-1.3 0-2.1.9-2.4 2h4zM185.1 46.3h1.1l-.2 1c.6-.8 1.5-1.2 2.5-1.2 1.3 0 1.9.6 1.9 1.8 0 .3-.1.8-.2 1.4l-.8 4h-1.1l.9-4c0-.3.2-.8.2-1.1 0-.7-.5-1-1.2-1-.6 0-1.3.3-1.7.8-.4.4-.6.9-.8 1.4l-.8 3.8h-1.1l1.3-6.9zM194.1 46.3h1.4l-.2 1h-1.4l-.9 4.1v.5c0 .4.3.5.7.5.2 0 .4-.1.7-.1l-.2 1c-.3.1-.5.1-.8.1-.8 0-1.6-.2-1.6-1.1 0-.2 0-.4.1-.6l.9-4.3h-1.2l.2-1h1.2l.4-2.1h1.1l-.4 2zM200.2 48.4c0-.8-.6-1.2-1.4-1.2-.7 0-1.5.2-1.5.9 0 .6.9.9 1.8 1.3s1.8.9 1.8 1.9c0 1.5-1.5 2.1-2.8 2.1-1.6 0-2.8-.6-2.8-2.3h1.1c-.1 1 .8 1.3 1.8 1.3.8 0 1.6-.3 1.6-1.1 0-.7-.9-.9-1.8-1.3s-1.8-.8-1.8-1.9c0-1.3 1.3-2 2.6-2s2.6.6 2.6 2.2h-1.2z"
            />
          </svg>
          <img v-else src="https://img66.anypromo.com/frontimg/HolidayLogo/logo-CA2.svg" style="width: 248px;height: 64px;">
        </div>
        <div v-if="ShowMVP" class="coupon-main-box vip-club">
          <div class="vip-club-title">
            Don't miss out! Join our VIP Club
            <span style="font-size: 32px">today!</span>
          </div>
          <input
            class="Galyon"
            id="txtEmail"
            type="text"
            name="searchterm"
            placeholder="Enter your email address"
            onfocus="Clear1(this)"
            onblur="Input1(this);"
          />
          <input
            type="button"
            value="Sign Up"
            class="sign-up"
            id="emailbutton"
          />
        </div>
        <platinum-member-box v-if="ShowMVP" :customerMVPInfo="mvpInfo!">
        </platinum-member-box>
      </aside>
      <div class="coupon-main">
        <section class="coupon-main-box">
          <h1>
            <span style="color: #f17121">Deal Center:</span> Save Cash, Promote,
            Win.
          </h1>
        </section>
        <section class="coupon-main-box terms-conditions">
          <div>
            <h2>Terms & Conditions</h2>
            <p class="Galyon">
              Coupon applies to item cost only. Before shipping and tax. Coupons
              cannot be combined, nor used on Flash Deals, "10 for 10", Last
              Call, nor special priced items. Please see the specific product
              page for more details.
            </p>
          </div>
        </section>
        <coupon-featured
          :couponShowCaseList="couponFeaturedList"
        ></coupon-featured>
        <coupon-page-normal
          :couponShowCaseList="couponNormalList">
        </coupon-page-normal>
      </div>
    </div>
    <div class="coupon-btm-text">
      <div class="coupon-btm-text-main">
        <div class="coupon-btm-title">
          Looking for AnyPromo Coupon & Promo codes?
          <span style="color: #25507c">Here you go!</span>
        </div>
        <p class="Galyon">
          What can be better than finding what you are looking for at the lowest
          price? When you have coupon/ promo codes on top of that! Here at
          AnyPromo, we stride to give our customers the best shopping experience
          possible by providing quality promotional products, exceptional
          service, and lowest price guarantee. But, that is still not suffice
          for us -- we would like to give customers like you an additional perk
          for choosing us as your place for all your Promotional product needs.
          We understand that finding the best prices and deals matters- we like
          to save money too!
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

import CouponFeatured from '@anypromo/components-mobile/coupon/CouponFeatured.vue'
import CouponPageNormal from '@anypromo/components-mobile/coupon/CouponPageNormal.vue'
import PlatinumMemberBox from '@anypromo/components-mobile/coupon/PlatinumMemberBox.vue'

import { CouponShowCaseModel } from '@anypromo/shared/types/Coupon'
import { CustomerMVPModel } from '@anypromo/shared/types/Customer'
import { GetCouponShowCase, GetCustomerMVPInfo } from '@anypromo/shared/api/CouponClient'

import {type CountryCode} from '@anypromo/shared/types/country'

export default defineComponent({
  name: 'App',
  components: { CouponFeatured, CouponPageNormal, PlatinumMemberBox },
  data () {
    return {
      couponFeaturedList: [] as Array<CouponShowCaseModel>,
      couponNormalList: [] as Array<CouponShowCaseModel>,
      mvpInfo: null as null | CustomerMVPModel
    }
  },
  props:{
    Country:{
      type: String as PropType<CountryCode>,
      default: ()=> "US"
    }
  },
  created () {
    GetCouponShowCase((window as any).couponPageFeatured).then(infos => {
      this.couponFeaturedList = infos
    })
    GetCouponShowCase((window as any).couponNormalType).then(infos => {
      this.couponNormalList = infos
    })
    GetCustomerMVPInfo().then(info => {
      this.mvpInfo = info
    })
  },
  computed:{
    ShowMVP(){
      return this.Country == "US"
    }
  }
})
</script>

<style>
.st0 {
  fill: #1c3664;
}

.st1 {
  fill: #f26622;
}
@font-face {
  font-family: "Gotham Black";
  src: url("/font/Gotham-Black.otf");
  font-display: swap;
}

.Galyon {
  font-family: Galyon, Helvetica, Arial, sans-serif;
}

.Galyon-Bold {
  font-family: "Galyon Bold", Helvetica, Arial, sans-serif;
  font-weight: 500;
}

.coupon-wrapper {
  font-family: "Gotham Black", Helvetica, Arial, sans-serif;
  color: #474747;
}

.coupon-wrapper h1 {
  font-size: 33px;
  margin: 0;
}

.coupon-wrapper h2 {
  font-size: 31px;
  margin: 0;
}

.coupon-wrapper h3 {
  font-size: 28px;
  color: #5d8ef9;
  margin: 0;
  line-height: 1.2;
}

.coupon-wrapper p {
  color: #7a7a7a;
  font-size: 16px;
  margin: 8px 0 0 0;
  line-height: 1.2;
}

.coupon-container {
  display: flex;
  justify-content: space-between;
  position: relative;
  top: -60px;
  max-width: 1200px;
  margin: 0 auto;
}

.coupon-container aside {
  width: 350px;
}

.coupon-main {
  width: 810px;
}

.coupon-main-box {
  width: 100%;
  border-radius: 25px;
  height: 124px;
  box-shadow: 5px 10px 10px 0px #dedede;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  margin-bottom: 35px;
  padding: 0 45px;
}

.terms-conditions {
  height: 191px;
  padding: 0 45px;
  margin-bottom: 23px;
}

.education-section {
  position: relative;
  height: 197px;
  border: 2px solid #5d8ef9;
  justify-content: flex-start;
  box-shadow: none;
  margin: 0;
}

.education-section p {
  font-size: 18px;
  display: inline-block;
  color: #474747;
  line-height: 1.5;
  margin: 5px 0 0 0;
}

.education-section img {
  position: absolute;
  right: 20px;
  bottom: 7px;
}

.clip-btn {
  width: 130px;
  height: 28px;
  background: #5d8ef9;
  font-size: 13px;
  border: 0;
  border-radius: 50px;
  color: #fff;
  cursor: pointer;
  vertical-align: text-bottom;
  margin: 0 7px;
  letter-spacing: 1px;
}

.clip-btn:hover {
  background: #446ecc;
}

.coupon-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.coupon-list li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #bcbec0;
  padding: 60px 0;
}

.coupon-list-title {
  font-size: 31px;
  line-height: 1.2;
  margin: 3px 0;
}

.coupon-list h2 {
  font-size: 24px;
}

.coupon-list p {
  font-size: 18px;
  display: inline-block;
  vertical-align: middle;
  margin: 10px 0 0 0;
}

.coupon-list em {
  font-style: normal;
  color: #5d8ef9;
}

.coupon-shop-now {
  width: 185px;
  height: 49px;
  border-radius: 50px;
  border: 1px solid #f26622;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #f26622;
  letter-spacing: 1px;
}

.coupon-shop-now:hover,
.coupon-shop-now:focus {
  color: #fff;
  text-decoration: none;
  background: #f26622;
}

.coupon-list .clip-btn {
  margin: 10px 0 0 15px;
  vertical-align: middle;
}

aside .logo-box {
  height: 124px;
}

aside .logo-box svg {
  width: 248px;
  height: 64px;
}

aside .vip-club {
  height: 309px;
  display: block;
  text-align: center;
  padding: 59px 0 0 0;
}

.vip-club-title {
  font-size: 25px;
  margin: 0 auto 37px auto;
  color: #5d8ef9;
  line-height: 1.2;
  padding: 0 40px;
  width: 312px;
  height: 78px;
  background: url("https://img66.anypromo.com/frontimg/2021/Coupon/coupon-text-bg.svg")
    no-repeat 0 0;
}

aside .vip-club input[type="text"] {
  width: 275px;
  height: 34px;
  border: 1px solid #bcbec0;
  border-radius: 50px;
  text-align: center;
}

aside .sign-up {
  width: 112px;
  height: 32px;
  border-radius: 50px;
  border: 0;
  background: #f17121;
  color: #fff;
  padding-bottom: 2px;
  margin-top: 14px;
  cursor: pointer;
}

aside .sign-up:hover {
  background: #cd4d08;
}

.platinum-member {
  background: #25507c;
  display: block;
  text-align: center;
  height: auto;
  color: #fff;
  padding: 39px 45px;
}

.platinum-member svg {
  width: 195px;
  height: 52px;
}

.platinum-member-title {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  margin: 15px 0 8px 0;
  width: 283px;
  height: 50px;
  background: url("https://img66.anypromo.com/frontimg/2021/Coupon/platinum-text-bg.svg")
    no-repeat 0 0;
}

aside .platinum-member h2 {
  font-size: 20px;
  padding: 0 10px;
}

aside .platinum-member ul {
  list-style-type: none;
  padding: 0;
  margin: 16px auto 22px auto;
  font-size: 18px;
  text-align: left;
  max-width: 145px;
  line-height: 1.2;
}

aside .platinum-member ul svg {
  width: 11px;
  height: 11px;
  margin-right: 5px;
}

aside .platinum-member .sign-up {
  width: 154px;
  height: 37px;
  background: #fff;
  color: #25507c;
  font-size: 17px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

aside .platinum-member .sign-up:hover,
aside .platinum-member .sign-up:focus {
  background: #ccc;
  text-decoration: none;
}

.coupon-btm-text {
  height: 347px;
  background: #5d8ef9;
  color: #fff;
  padding-top: 58px;
}

.coupon-btm-text-main {
  max-width: 720px;
  margin: 0 auto;
  text-align: center;
}

.coupon-btm-title {
  padding: 0 90px 5px 90px;
  line-height: 1.2;
  font-size: 33px;
  margin: 0;
}

.coupon-btm-text p.Galyon {
  color: #fff;
}

@media (max-width: 1200px) {
  .coupon-main {
    width: calc(100vw - 430px);
  }

  .coupon-container {
    padding: 0 15px;
  }

  .coupon-list p,
  .education-section p {
    display: block;
  }

  .clip-btn,
  .coupon-list .clip-btn {
    margin-left: 0;
  }

  .education-section {
    height: auto;
    padding: 20px 45px;
  }

  .education-section img {
    width: 30%;
  }
}

@media (max-width: 992px) {
  .coupon-container aside {
    width: 30%;
  }

  .coupon-main {
    width: 68%;
  }

  aside .vip-club input[type="text"] {
    width: 100%;
    font-size: 13px;
  }

  .platinum-member,
  aside .vip-club {
    padding: 20px;
    height: auto;
  }

  aside .vip-club h1,
  .platinum-member-title {
    width: 100%;
    height: auto;
    padding: 0;
    font-size: 20px;
    background-size: cover;
  }

  aside .vip-club h1 {
    padding: 0 40px;
  }

  aside .platinum-member h2 {
    font-size: 15px;
  }

  .platinum-member svg {
    width: 150px;
    height: 40px;
  }
}

@media (max-width: 768px) {
  .coupon-container {
    display: block;
    top: 0;
    margin: 30px 0;
  }

  .coupon-main,
  .coupon-container aside {
    width: 100%;
  }

  .coupon-btm-text {
    height: auto;
    padding: 30px 15px;
  }
}

@media (max-width: 540px) {
  .coupon-list li {
    display: block;
    padding: 30px 0;
  }

  .coupon-shop-now {
    margin-top: 15px;
    width: 100%;
  }

  .coupon-list-title,
  .coupon-wrapper h1 {
    font-size: 20px;
  }

  .coupon-list h2,
  .coupon-wrapper h2,
  .coupon-wrapper h3 {
    font-size: 17px;
  }

  .coupon-list p,
  .coupon-wrapper p,
  .education-section p span {
    font-size: 14px !important;
  }

  .coupon-main-box {
    padding: 15px;
  }

  .coupon-btm-title {
    padding: 0;
  }
}

@media (max-width: 992px) and (min-width: 768px) {
  .vip-club-title {
    width: auto;
    height: auto;
    padding: 0 20px;
    font-size: 20px;
    margin-bottom: 15px;
  }

  .vip-club-title span {
    font-size: 25px !important;
  }
}
</style>
